import { getRouteApi } from '@tanstack/react-router';

// Shared typed accessor for the /travel-credit-card route, whose loader fetches
// the per-user CVP server-side (see routes/travel-credit-card.tsx). Components
// rendered under that route read the CVP via `cbccRouteApi.useLoaderData()`
// instead of a client-side fetch — so `screens`/`userFlow` are request-scoped
// (no cross-request leak through a module singleton) and present on first paint.
export const cbccRouteApi = getRouteApi('/travel-credit-card');
